import React, { useState } from "react";
import { Link } from "react-router-dom";
import { research } from "../../TextData/researchData";
import { Research } from "./Research/Research";
import "./research-groups.scss";
export const ResearchGroups = () => {
  const [state, setState] = useState({
    query: "",
    list: research,
  });

  return (
    <>
      {" "}
      <div className="postgraduate-page">
        <center>
          <h1>research areas</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Research</h6>
        </div>
      </div>
      <center>
        <div className="col-md-6 mtt">
          <p>
            The Department operates on a devolved research basis, based upon a
            Research Group structure. Each Research Group has its own culture
            and strategy matched to the cutting edge of contemporary science in
            that area. Collaborative projects between groups are strongly
            encouraged.
          </p>
          <p>
            The Research Group structure evolves over time in response to
            changing priorities and opportunities. The links below provide
            top-level descriptions of the Research Groups, as well as links to
            the Research Groups' own web-pages which provide detailed
            descriptions of the research, the personnel and contact details.
          </p>
        </div>
      </center>
      <div className="row row-cols-2 row-cols-lg-3  g-lg-2 col-md-8 offset-md-2 mt8">
        {state.list.map((data, index) => (
          <Research data={data} />
        ))}
      </div>
    </>
  );
};
